import {
  Price_Normal_Item,
  SingleServiceType,
  SupplierPriceType,
} from "@pages/offerCreate/types";
import type { OfferServicesRow } from "@pages/offerView/types";

export const ShippingCasesPricesByIdStatus = {
  NEW: "NEW",
  COPIED: "COPIED",
  UPDATED: "UPDATED",
  CANCELED: "CANCELED",
} as const;

export const InvoiceStatus = {
  NONE: "NONE",
  TO_DO: "TO_DO",
  PARTIAL: "PARTIAL",
  COMPLETED: "COMPLETED",
} as const;

export const InvoiceFrequency = {
  END_OF_MONTH: "END_OF_MONTH",
  IMMEDIATE: "IMMEDIATE",
  ON_COMPLETION: "ON_COMPLETION",
  MANUAL: "MANUAL",
} as const;

export type InvoiceStatusType =
  (typeof InvoiceStatus)[keyof typeof InvoiceStatus];

export type InvoiceFrequencyType =
  (typeof InvoiceFrequency)[keyof typeof InvoiceFrequency];

export type RequestShippingCasesPricesByIdParams = {
  page: number;
  size: number;
  customer_id?: number;
  office_id?: number;
  status?: keyof typeof ShippingCasesPricesByIdStatus;
  status__neq?: keyof typeof ShippingCasesPricesByIdStatus;
  show_all?: boolean;
  order_by?: string;
};

export type RequestShippingCasesPricesCustomersParams = {
  customer_id?: number;
  office_id?: number;
  status?: keyof typeof ShippingCasesPricesByIdStatus;
  status__neq?: keyof typeof ShippingCasesPricesByIdStatus;
  order_by?: string;
};

export type ShippingCasesPricesByIdItemCustomer = {
  id: number;
  name: string;
};

export type ShippingCasesPricesByIdItemOffice = {
  id: number;
  name: string;
};

export type ShippingCasesPricesByIdItemStatus =
  keyof typeof ShippingCasesPricesByIdStatus;
export type ShippingCasesPricesByIdItem = OfferServicesRow & {
  customer: ShippingCasesPricesByIdItemCustomer;
  office: ShippingCasesPricesByIdItemOffice;
  status: keyof typeof ShippingCasesPricesByIdStatus;
  invoice_status: keyof typeof InvoiceStatus | null;
  invoice_frequency: keyof typeof InvoiceFrequency | null;
  invoice_note?: string | null;
  active_price_editable: boolean;
};

export type ShippingCasesPricesByIdResponse = {
  items: ShippingCasesPricesByIdItem[];
  total: number;
  page: number;
  size: number;
};

export type ShippingCasesPricesCustomersRequest = {
  shipping_case_id: number;
};

export type ShippingCasesPricesCustomersResponse = {
  id: number;
  name: string;
};

export type CancelShippingCasesByPricesIdResponse = {
  detail: {
    loc: Array<string | number>;
    msg: string;
    type: string;
  }[];
};

export type EditShippingCasesByPricesIdResponse = {
  id: number;
  active_price_editable: boolean;
  invoice_status: keyof typeof InvoiceStatus | null;
  invoice_frequency: keyof typeof InvoiceFrequency | null;
  invoice_note?: string | null;
  active_price_updated_manually?: boolean;
  active_price: SingleServiceType | null;
  passive_prices: SupplierPriceType[] | null;
  shipping_case_id: number;
  status: string;
  office: ShippingCasesPricesByIdItemOffice;
  customer: ShippingCasesPricesByIdItemCustomer;
};

export type EditShippingCasesByPricesIdRequest = {
  customer_id: number;
  office_id: number;
  active_price_id?: number;
  passive_price_ids?: number[];
  prices?: number[];
  expiration_date?: string;
  comment?: string;
  invoice_note?: string;
  status?: keyof typeof ShippingCasesPricesByIdStatus;
  invoice_frequency?: keyof typeof InvoiceFrequency | null;
  invoice_status?: keyof typeof InvoiceStatus | null;
};

export type SaveManageServicesRequest = {
  prices: {
    id?: number;
    active_price_id: number;
    passive_price_ids: number[];
    customer_id: number;
    office_id: number;
    prices: (number | null)[];
    expiration_date: string;
    comment: string;
  }[];
};

export type ModifyPricePayload = {
  active_price_data: {
    data: Partial<Price_Normal_Item>[] | null;
    type: string;
  };
};
